import savingActionTypes from '../../constants/saving-action-types';

const deleteAsset = (source) => ({
  type: savingActionTypes.DELETE_ASSET,
  source,
});

export default deleteAsset;
